<template>
	<el-menu class="navbar" mode="horizontal">
		<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
		<levelbar></levelbar>
		<div style="position: absolute;top: 0;right: 150px;"><el-link type="primary" href="https://udify.app/chat/Offovt016fS3JoEv" target="_blank">AI助手<i class="el-icon-chat-line-round"></i></el-link></div>
		<!-- <el-link type="info" class="companyInfo">账户信息</el-link> -->
		<el-dropdown class="avatar-container" trigger="click">
			
			<div class="avatar-wrapper" style="margin-top:0px;">
				{{name}}
				<!-- <img class="user-avatar" src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"> -->
				<i class="el-icon-caret-bottom"></i>
			</div>
			<el-dropdown-menu class="user-dropdown" slot="dropdown">
				<router-link class='inlineBlock' to="/">
					<el-dropdown-item>
						首页
					</el-dropdown-item>
				</router-link>
				<router-link to="/User/UserInfo">
					<el-dropdown-item>
						个人资料
					</el-dropdown-item>
				</router-link>
				<el-dropdown-item divided><span @click="logout" style="display:block;">退出登录</span></el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</el-menu>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Hamburger from '@/components/Hamburger'
	import Levelbar from './Levelbar'
	import { removeToken } from '@/utils/auth'
	export default {
	  name: 'Navbar',
	  components: {
    	Hamburger,
    	Levelbar
  	  },
  	  data(){
  	  	return {

  	  	}
  	  },
  	  computed: {
	  	...mapGetters([
	      'sidebar',
	      'name',
	      'avatar'
	    ])
  	  },
	  methods: {
	    toggleSideBar() {
	      this.$store.dispatch('ToggleSideBar')
	    },
	    logout() {
	    //   this.$store.dispatch('LogOut').then(() => {
	    //     location.reload()// 为了重新实例化vue-router对象 避免bug
		//   })
		removeToken();
		location.reload();
     }
  	}
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
	.navbar {
			height: 50px;
			line-height: 50px;
			border-radius: 0px !important;
			background: #eef1f6;
			.hamburger-container {
					line-height: 58px;
					height: 50px;
					float: left;
					padding: 0 10px;
					outline: none;
			}
			.errLog-container {
					display: inline-block;
					position: absolute;
					right: 150px;
			}
			.screenfull {
					position: absolute;
					right: 90px;
					top: 16px;
					color: red;
			}
			.avatar-container {
					height: 50px;
					display: inline-block;
					position: absolute;
					right: 35px;
					outline:none;
					.avatar-wrapper {
							cursor: pointer;
							margin-top: 5px;
							position: relative;
							.user-avatar {
									width: 40px;
									height: 40px;
									border-radius: 10px;
							}
							.el-icon-caret-bottom {
									position: absolute;
									right: -20px;
									top: 20px;
									font-size: 12px;
							}
					}
			}
	}
	.companyInfo{
		display: inline-block;
		line-height: 50px;
		height: 50px;
		position: absolute;
		right: 100px;
	}
</style>
